module.exports = function() {
  return new Worker(__webpack_public_path__ + "0677d9106a3925e1c00c.worker.js");
};